<div class="wizard-ai-voice" [class.wizard-ai-voice--loading]="showDots">
  <span #source class="wizard-ai-message-source">{{ translationKey | translate: translationParams }}</span>
  @if (showDots) {
    <span class="wizard-ai-dots" aria-hidden="true">
      <span class="wizard-ai-dot"></span>
      <span class="wizard-ai-dot"></span>
      <span class="wizard-ai-dot"></span>
    </span>
    @if (dotLabel) {
      <span class="wizard-ai-dot-label">{{ dotLabel }}</span>
    }
  } @else {
    <p class="wizard-ai-text">{{ typedText }}<span class="wizard-ai-cursor" [class.wizard-ai-cursor--visible]="showCursor"></span></p>
  }
</div>
